var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGradientHeading(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 22,
    viewBox: "0 0 27 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.2993 3.04217C11.0681 3.74857 10.0727 4.3634 9.31303 4.88666C8.55338 5.38375 7.78063 6.05091 6.99478 6.88812C6.26132 7.67301 5.69813 8.49715 5.30521 9.36052C4.91228 10.2239 4.63724 11.3358 4.48007 12.6963H6.3661C7.99019 12.6963 9.26064 13.1018 10.1775 13.9129C11.1205 14.6978 11.592 15.862 11.592 17.4056C11.592 18.5045 11.1729 19.5379 10.3346 20.5059C9.52259 21.4478 8.39621 21.9188 6.95549 21.9188C4.70272 21.9188 3.09173 21.1862 2.12252 19.7211C1.15331 18.2298 0.668701 16.2806 0.668701 13.8736C0.668701 12.173 1.03543 10.6294 1.76889 9.24279C2.50235 7.82999 3.39298 6.57417 4.44077 5.47532C5.51477 4.35032 6.65425 3.39537 7.85921 2.61048C9.06418 1.82559 10.0727 1.1846 10.8847 0.6875L12.2993 3.04217ZM26.8375 3.04217C25.6063 3.74857 24.6109 4.3634 23.8512 4.88666C23.0916 5.38375 22.3188 6.05091 21.533 6.88812C20.7733 7.69918 20.197 8.53639 19.8041 9.39977C19.4374 10.237 19.1754 11.3358 19.0183 12.6963H20.9043C22.5284 12.6963 23.7988 13.1018 24.7157 13.9129C25.6587 14.6978 26.1302 15.862 26.1302 17.4056C26.1302 18.5045 25.7111 19.5379 24.8728 20.5059C24.0608 21.4478 22.9344 21.9188 21.4937 21.9188C19.2409 21.9188 17.6299 21.1862 16.6607 19.7211C15.6915 18.2298 15.2069 16.2806 15.2069 13.8736C15.2069 12.173 15.5736 10.6294 16.3071 9.24279C17.0405 7.82999 17.9312 6.57417 18.979 5.47532C20.053 4.35032 21.1924 3.39537 22.3974 2.61048C23.6024 1.82559 24.6109 1.1846 25.4229 0.6875L26.8375 3.04217Z",
    fill: "url(#paint0_linear_3200_18345)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3200_18345",
    x1: -3.69276,
    y1: 0.6875,
    x2: 21.3341,
    y2: 27.1279,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4CFFE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.706855,
    stopColor: "#185B74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#021744"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGradientHeading);
export default __webpack_public_path__ + "static/media/GradientHeading.693f07c5fe315e9aaec9da265389160b.svg";
export { ForwardRef as ReactComponent };